<template>
  <footer>
    <div class="foot">
      <div class="cont">
        <p>技术支持：中城绿脉（湖北）网络科技有限公司</p>
        <p>热线：027-87338646</p>
      </div>
    </div>
    <div class="bot">Copyright.©2020 Etesting. All Rights Reserved.</div>
  </footer>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
footer {
  width: 100%;
  height: 130px;
  background: #333;
  color: #dedede;
  // margin-top: 30px;
  // position: fixed;
  // left: 0;
  // bottom: 0;
  // z-index: 5;
}
.foot {
  width: 1200px;
  height: 80px;
  margin: 0 auto;
  padding: 20px 0;
  .cont {
    text-align: center;
  }
}
.bot {
  text-align: center;
  height: 50px;
  line-height: 50px;
  border-top: 1px solid #666464;
  font-size: 12px;
}
</style>
